import { Button, Flex, Grid, Loader, MultiSelect, Select, Stack, TextInput, Radio, Group } from "@mantine/core";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import PhoneInputField from "../../components/PhoneInputField/PhoneInputField";
import axios from "axios";
import { createRef, useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useAppContext } from "../../context/AppState/AppContext";
import showNotification from "../../utils/showNotification";



export default function Sorteo() {

    const { specialtiesInfo } = useAppContext();
    const [specialtiesData, setSpecialtiesData] = useState([])
    const [randomQuestion, setRandomQuestion] = useState(null);
    const [questionResponse, setQuestionResponse] = useState({
        correctValue: null,
        selectedValue: null
    });

    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            phone: '',
            alreadyStudent: "NO",
            specialties: [],
            question: []
        },

        validate: {
            name: (value) => (value.length > 5 ? null : 'Ingrese su nombre completo'),
            email: (value) => (/^\S+@\S+$/.test(value) ? null : 'El email ingresado no es valido'),
            phone: (value) => {
                if (typeof value === "string")
                    return !isValidPhoneNumber(value)
                else return true
            }
        },
    });
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (specialtiesInfo?.data) {
            setSpecialtiesData(specialtiesInfo?.data.map(specialty => specialty.name.toUpperCase()));
        }
    }, [specialtiesInfo]);

    useEffect(() => {
        const fetchRandomQuestion = async () => {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/random-question`);
                setRandomQuestion(data);
            } catch (error) {
                console.error("Error al obtener la pregunta aleatoria:", error);
            }
        };
        fetchRandomQuestion();
    }, []);


    const handleSubmit = async (values) => {

        setIsLoading(true)

        try {
            const IS_QUESTION_CORRECT = (questionResponse.selectedValue !== null) && (String(questionResponse?.correctValue) === String(questionResponse?.selectedValue))

            // create lead

            const createLeadJsonData = {
                email: values.email,
                name: values.name,
                phone: values.phone,
                alreadyStudent: values.alreadyStudent,
                is_correct_answer: IS_QUESTION_CORRECT,
                interestAreas: Array.isArray(values.specialties) ? values.specialties : [values.specialties],
                source: 'SORTEO_PAGE',
                sendEmail: false,
                flow: 'SORTEO_FLOW',
            }


            await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/createLead`, createLeadJsonData)

            const message = IS_QUESTION_CORRECT ? "¡Felicidades! ¡Tenés doble chance de ganar!" : "No respondiste la pregunta correctamente";

            showNotification({
                message: message,
                color: "green",
                status: "success",
                title: "¡Ya estás participando del sorteo!"
            })

        } catch (error) {
            console.log(error)
            showNotification({
                color: "red",
                status: "error",
                title: "Error",
                message: `Error al enviar tus datos`,
            });
        } finally {
            setIsLoading(false)
        }
    }

    const ref = createRef()

    return (
        <>
            <MainLayout>

                <div className="SubscriptionPage-main-container">
                    <h1 className="landingHero__title">
                        Tenemos <br />
                        <span className="landingHero__gradient">
                            sorteo
                        </span>
                    </h1>
                    <Stack mb={20}>
                        <p className='SubscriptionPage--description'>
                            Completá el formulario y obtené un gran beneficio.
                        </p>
                        <p className='SubscriptionPage--description' style={{marginTop: '-16px'}}>
                            Si respondes bien la pregunta, <strong> sumás doble chance. 😉</strong>
                        </p>
                        {/* <p className='SubscriptionPage--description'>
                     Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá.
                  </p> */}
                    </Stack>

                    <form
                        style={{
                            width: "100%",
                            maxWidth: "768px",
                            margin: '0 auto',
                            color: 'var(--color-text-primary)'
                        }}
                        onSubmit={
                            form.onSubmit((values) => handleSubmit(values))
                        }>
                        <Grid>
                            <Grid.Col span={6}>
                                <TextInput
                                    label='Escribe tu nombre'
                                    {...form.getInputProps('name')}
                                    placeholder="Juan"
                                    required
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <TextInput
                                    placeholder="Perez"
                                    required
                                    label='Escribe tu email'
                                    {...form.getInputProps('email')}
                                />
                            </Grid.Col>
                            <Grid.Col span={12}>
                                <PhoneInputField
                                    ref={ref}
                                    required
                                    name="phone"
                                    fieldError={form.errors.phone}
                                    {...form.getInputProps("phone")}
                                />
                            </Grid.Col>
                            <Grid.Col span={12}>
                                {specialtiesInfo && <MultiSelect
                                    data={specialtiesData}
                                    label='Especialidades de interés'
                                    {...form.getInputProps('specialties')}
                                />}
                            </Grid.Col>
                            <Grid.Col span={12}>
                            <Radio.Group
                                name="alreadyStudent"
                                value={form.values.alreadyStudent}
                                onChange={(value) => {
                                    form.setFieldValue('alreadyStudent', value)
                                }}
                                label="¿Has participado en alguna capacitación de FORVET?" withAsterisk
                                >
                                    <Radio value="SI" label="Si" />
                                    <Radio value="NO" label="No" />
                                </Radio.Group>
                            </Grid.Col>
                            {randomQuestion !== null && <Grid.Col mt={16} span={12}>
                                <h3 style={{ fontSize: 'var(--fs-body)', textAlign: 'center', fontWeight: 400, marginTop: '32px' }}>¿Te animas a responder? Si acertas, sumas doble chance</h3>
                                <h3 style={{ fontSize: 'var(--fs-body)', border: '1px solid var(--color-text-primary)', padding: "1rem", borderRadius: 'var(--border-radius-md)', fontWeight: 400, margin: '1rem 0', fontStyle: "italic" }}>{`"${randomQuestion.questionText}"`}</h3>
                                <Select
                                    placeholder="Selecciona una respuesta"
                                    onChange={(value) => {
                                        setQuestionResponse({
                                            selectedValue: value,
                                            correctValue: randomQuestion.trueOption
                                        })
                                    }}
                                    data={randomQuestion.responseOptions.map(item => {
                                        return { value: String(item.value), label: item.label }
                                    })
                                    } 
                                />


                            </Grid.Col>}
                            <Grid.Col span={12} mt={16}>
                                <Button fullWidth color='#FF7BAC' type='submit' disabled={isLoading}>
                                    {isLoading ? <Loader /> : <Flex align='center' gap={8}><span style={{ fontSize: "var(--fs-small)" }} >Participar</span></Flex>}
                                </Button>
                            </Grid.Col>
                        </Grid>
                    </form>
                </div>
            </MainLayout>
        </>
    )
}
